/** 驗證手機號碼 */
export const validateTaiwanMobile = (rule: any, value: any, callback: any): void => {
  const nuxtApp = useNuxtApp()
  if (!value) {
    callback()
  } else {
    if (!/^09\d{8}$/.test(value)) {
      callback(new Error(nuxtApp.$i18n.t('taiwan_mobile_validate')))
    } else {
      callback()
    }
  }
}

/** 驗證驗證是否同意 */
export const validateAgreement = (rule: any, value: any, callback: any): void => {
  const nuxtApp = useNuxtApp()
  if (value) {
    callback()
  } else {
    callback(new Error(nuxtApp.$i18n.t('agreement_validate')))
  }
}

/** 驗證統一編號 */
export const validateTaiwanUBN = (rule: any, value: any, callback: any): void => {
  const nuxtApp = useNuxtApp()
  if (!value) {
    return callback()
  }
  if (!/^\d{8}$/.test(value)) {
    return callback(new Error(nuxtApp.$i18n.t('taiwan_UBN_validate')))
  }
  callback()
}

/** 驗證只能中文與數字輸入 */
export const validateNumberAndChinese = (rule: any, value: any, callback: any) => {
  if (!value) {
    return callback(new Error('請輸入文字'))
  }
  if (!/^[\u4e00-\u9fa5\d]+$/.test(value)) {
    return callback(new Error('文字只能包含數字和中文'))
  }
  callback()
}

/** 驗證只能中文輸入 */
export const validateChineseOnly = (rule: any, value: any, callback: any) => {
  if (!value) {
    return callback(new Error('請輸入文字'))
  }
  if (!/^[\u4e00-\u9fa5]+$/.test(value)) {
    return callback(new Error('文字必須只包含中文'))
  }
  callback()
}

/** 驗證最小數字 */
export const validateMin = (min: number, msg?: string) => {
  return async (ule: any, value: any, callback: any) => {
    if (value === '') {
      callback(new Error('請輸入數字'))
    } else {
      if (!/^\d+$/.test(value)) {
        callback(new Error('請輸入數字'))
      } else {
        if (min > Number(value)) {
          callback(new Error(msg || `請輸入大於${min}的數字`))
        }
        callback()
      }
    }
  }
}

/** 驗證手機載具碼格式 */
export const validateTaiwanMobileCarrier = (rule: any, value: any, callback: any) => {
  const nuxtApp = useNuxtApp()
  if (!value) {
    callback()
  }
  // 驗證格式為 / 加上 7 位英數字
  if (!/^\/[A-Za-z0-9]{7}$/.test(value)) {
    return callback(new Error(nuxtApp.$i18n.t('taiwan_mobile_carrier_validate')))
  }
  callback()
}
/** 驗證自然人載具碼格式 */
export const validateTaiwanCitizenDigitalCertificate = (rule: any, value: any, callback: any) => {
  const nuxtApp = useNuxtApp()
  if (!value) {
    callback()
  }
  // 驗證格式為 2 位英文字母 + 14 位數字
  if (!/^[A-Za-z]{2}\d{14}$/.test(value)) {
    return callback(new Error(nuxtApp.$i18n.t('taiwan_digital_validate')))
  }
  callback()
}

/**驗證是否為網址 */
export const validateUrl = (rule: any, value: any, callback: any) => {
  const nuxtApp = useNuxtApp()
  if (!value) {
    return callback()
  }
  const urlPattern = /^(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w \.-]*)*\/?$/
  if (!urlPattern.test(value)) {
    return callback(new Error(nuxtApp.$i18n.t('url_validate')))
  }
  callback()
}
